// src/slices/1-auth/1-login/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const loginUser = createAsyncThunk("auth/loginUser", async (credentials, { rejectWithValue }) => {
  try {
    const response = await axios.post(API_URL + "/auth/signin", credentials);

    const data = response?.data.data || response.data;

    const authUser = { status: "success", data: { email: data.user?.email || data.email, username: data.user?.fullName || data.username, token: data.token?.startsWith("Bearer") ? data.token : `Bearer ${data.token}` } };

    sessionStorage.setItem("authUser", JSON.stringify(authUser));

    return authUser;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

export const signupUser = createAsyncThunk("auth/signupUser", async (userData, { rejectWithValue }) => {
  try {
    const response = await axios.post(API_URL + "/auth/signup", userData);

    const data = response.data.data || response.data;

    const authUser = { status: "success", data: { email: data.user?.email || data.email, username: data.user?.fullName || `${data.firstName} ${data.lastName}`, token: data.token?.startsWith("Bearer") ? data.token : `Bearer ${data.token}` } };

    sessionStorage.setItem("authUser", JSON.stringify(authUser));

    return authUser;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Signup failed");
  }
});

export const googleLogin = createAsyncThunk("auth/googleLogin", async (googleData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/auth/google`, googleData);
    const data = response.data.data || response.data;

    const authUser = { status: "success", data: { email: data.user?.email || data.email, username: data.user?.fullName || data.username, token: data.token?.startsWith("Bearer") ? data.token : `Bearer ${data.token}` } };

    sessionStorage.setItem("authUser", JSON.stringify(authUser));
    return authUser;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Google login failed");
  }
});

export const forgetPassword = createAsyncThunk("auth/forgetPassword", async (emailData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/auth/forgetPassword`, emailData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Password reset failed");
  }
});

export const verifyOTP = createAsyncThunk("auth/verifyOTP", async (otpData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/auth/signup/configurationOTP`, otpData);

    const data = response.data.data || response.data;

    const authUser = {
      status: "success",
      data: { email: data.user?.email || data.email, username: data.user?.fullName || `${data.user?.firstName || ""} ${data.user?.lastName || ""}`, token: data.token?.startsWith("Bearer") ? data.token : `Bearer ${data.token}` }
    };

    sessionStorage.setItem("authUser", JSON.stringify(authUser));

    return authUser;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "OTP verification failed");
  }
});

export const resendOTP = createAsyncThunk("auth/resendOTP", async (email, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/auth/resendOTP`, { email });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to resend OTP");
  }
});

export const resetPassword = createAsyncThunk("auth/resetPassword", async ({ token, passwordData }, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${API_URL}/auth/resetPassword`, passwordData, { headers: { Authorization: `Bearer ${token}` } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Password reset failed");
  }
});

export const changePassword = createAsyncThunk("auth/changePassword", async ({ passwordData }, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));

    const token = tokenData?.data?.token?.replace("Bearer ", "");

    const response = await axios.post(`${API_URL}/auth/changePassword`, passwordData, { headers: { Authorization: `Bearer ${token}` } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Password reset failed");
  }
});
